/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compliance_Link_Distance_ContractInputs */

const tr_pricing_compliance_link_distance_contract = /** @type {(inputs: Pricing_Compliance_Link_Distance_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesafeli Satış Sözleşmesi`)
};

const en_pricing_compliance_link_distance_contract = /** @type {(inputs: Pricing_Compliance_Link_Distance_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance Sales Agreement`)
};

const de_pricing_compliance_link_distance_contract = /** @type {(inputs: Pricing_Compliance_Link_Distance_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fernabsatzvertrag`)
};

const ru_pricing_compliance_link_distance_contract = /** @type {(inputs: Pricing_Compliance_Link_Distance_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Договор дистанционной продажи`)
};

/**
* | output |
* | --- |
* | "Distance Sales Agreement" |
*
* @param {Pricing_Compliance_Link_Distance_ContractInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compliance_link_distance_contract = /** @type {((inputs?: Pricing_Compliance_Link_Distance_ContractInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compliance_Link_Distance_ContractInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_compliance_link_distance_contract(inputs)
	if (locale === "de") return de_pricing_compliance_link_distance_contract(inputs)
	if (locale === "ru") return ru_pricing_compliance_link_distance_contract(inputs)
	return tr_pricing_compliance_link_distance_contract(inputs)
});